/**
 * ---------------------------------------------------------------------------
 * Mobile swipe gallery on product cards  (custom addition, not part of Impact)
 * ---------------------------------------------------------------------------
 * The swiping itself is native scroll-snap, so it needs no JavaScript at all.
 * This file only moves the little progress bar under the image in sync with
 * the scroll position.
 *
 * The listener is registered on the document in the capture phase, because
 * scroll events do not bubble. That way it keeps working for the cards that
 * the endless scroll appends later, with nothing to re-bind.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__pcSwipeReady) return;
  window.__pcSwipeReady = true;

  function update(scroller) {
    var figure = scroller.closest('.product-card__figure');
    if (!figure) return;

    var track = figure.querySelector('.pc-swipe__track');
    if (!track) return;

    var max = scroller.scrollWidth - scroller.clientWidth;
    var progress = max > 0 ? Math.abs(scroller.scrollLeft) / max : 0;

    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;

    track.style.setProperty('--pc-p', progress.toFixed(4));
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;

      if (target && target.nodeType === 1 && target.classList && target.classList.contains('pc-swipe')) {
        update(target);
      }
    },
    true
  );
})();
